import Icon from '../components/Icon.vue'

Icon.register({
  'hat-cowboy': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M490 296.9c-38.8 12.6-93.7 23.1-170 23.1s-131.2-10.5-170-23.1c9.5-57.4 39.5-232.9 97.7-232.9 14 0 26.5 6 37 14 8.6 6.6 24.4 11.9 35.3 11.9s26.7-5.3 35.3-11.9c10.5-8.1 23-14 37-14 58.2 0 88.2 175.5 97.7 232.9zM632.9 259.7c3.9 2.6 7.1 8.6 7.1 13.3 0 1.6-0.4 4.1-1 5.5-0.7 2-77.3 201.5-319 201.5s-318.3-199.4-319-201.5c-0.5-1.5-1-3.9-1-5.5 0-8.8 7.2-16 16-16 3.4 0 8.2 1.8 10.7 4.1 1 0.9 102.4 90.8 293.2 90.8 191.9 0 292.2-89.9 293.2-90.8 2.5-2.3 7.4-4.2 10.8-4.2 2.7 0 6.7 1.2 8.9 2.7z'
      }
    ]
  }
})
